// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5878) return "static/chunks/5878-cd4aa8aa9ba578b4.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8445 ? "bc98253f" : chunkId) + "." + {"167":"0f65ddd83d526172","1411":"9a3ba646e0060601","3969":"c0debc7eda1f64e1","8445":"b5b66739297457d0"}[chunkId] + ".js";
};